export default {
  methods: {
    async hasValidPrinter() {
      await this.$store.dispatch('syncPrinterFromStorage')
      return !!this.defaultPrinter
    },
    async executeWithPrinterValidation(action) {
      const isWebSocketConnected = this.webSocketStatus?.connectionState === 'connected'

      if (!isWebSocketConnected) {
        this.$refs.printerPluginDownloadModal.forceOpen()
        return
      }

      const hasValidPrinter = await this.hasValidPrinter()

      if (hasValidPrinter) {
        await this.$nextTick()
        action()
      } else {
        this.openConfigModal()
      }
    },
    async initializePrinterFromStorage() {
      await this.$store.dispatch('syncPrinterFromStorage')
    },
  },
}
